import React, { useState } from 'react';
import { FiPlus, FiBookOpen } from 'react-icons/fi';
import AccountingSidebar from '../components/AccountingSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [];

export default function ChartOfAccounts() {
  const [data, setData] = useLocalState('coa_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'code', direction: 'asc' });

  const handleAdd = (newData) => { setData([{ ...newData, status: 'Active' }, ...data]); };
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <AccountingSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1 text-gray-800">
          <div className="flex items-center space-x-2">
            <FiBookOpen className="text-xl opacity-70 text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Chart of Accounts ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded shadow-sm hover:bg-blue-900 transition-colors">
            <FiPlus className="text-sm" />
          </button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black shadow-sm">
          <table className="min-w-full border-collapse text-[12px] text-gray-800">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900 select-none">
                <th onClick={() => handleSort('code')} className="font-normal p-2 border border-black text-left cursor-pointer">Account Code</th>
                <th onClick={() => handleSort('name')} className="font-normal p-2 border border-black text-left cursor-pointer">Account Name</th>
                <th onClick={() => handleSort('type')} className="font-normal p-2 border border-black text-left cursor-pointer">Type</th>
                <th className="font-normal p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black font-bold">{row.code}</td>
                  <td className="p-2 border border-black">{row.name}</td>
                  <td className="p-2 border border-black">{row.type}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-green-100 text-green-800 px-2 py-0.5 rounded">{row.status}</span></td>
                </tr>
              ))}
              {sortedData.length === 0 && <tr><td colSpan="4" className="p-4 text-center text-gray-500">No records found</td></tr>}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Account" fields={[
          { name: 'code', label: 'Account Code' }, { name: 'name', label: 'Account Name' }, { name: 'type', label: 'Type (Asset/Liability/Equity/Revenue/Expense)' }
        ]} />
      </div>
    </div>
  );
}